module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "max-width": "320"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.dialogTitle))]), _vm._v(" "), _c('v-card-text', [_vm._v(_vm._s(_vm.dialogText))]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$emit('onConfirm')
      }
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('v-btn', {
    staticClass: "orange--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.$emit('onCancel')
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bf471a5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmDialog.vue
// module id = 400
// module chunks = 1